import React from 'react';
import { KiteGrid } from '@kite/react-kite';
import styles from 'components/footer/styles/Footer.module.scss';
import Legal from 'components/footer/Legal';
import SpectrumLinks from 'components/footer/SpectrumLinks';

interface Props {
  showLogo: boolean;
  showCanaryFooter: boolean;
  showSpectrumLinks?: boolean;
}

const Footer: React.FC<Props> = ({ showLogo, showCanaryFooter, showSpectrumLinks }) => {
  return (
    <>
      <aside className={`${styles.footer}`}>
        <KiteGrid className={styles.pageFooter}>
          {showSpectrumLinks && <SpectrumLinks />}
          {showSpectrumLinks && <div className={styles.legalDivider} />}
          <Legal showCanaryFooter={showCanaryFooter} showLogo={showLogo} />
        </KiteGrid>
      </aside>
    </>
  );
};

export default Footer;
